import React, {useState} from 'react';

import {Button} from "react-bootstrap";
import InterimPaymentModal from "../InterimPaymentModal";
import RenderIf from "../RenderIf";

const InterimPayment = () => {
    const [showInterimPayment, setShowInterimPayment] = useState(false);

    return(
        <>
            <Button onClick={() => setShowInterimPayment(true)} variant="primary ml-auto" className="my-4">Aralıq ödənişi</Button>
            <RenderIf condition={showInterimPayment}>
                <InterimPaymentModal show={showInterimPayment} onHide={setShowInterimPayment}/>
            </RenderIf>
        </>
    )
}

export default InterimPayment